export * from './question';
export * from './logic';
export * from './async';

import { logicSlice } from './slice';

const Reducer = logicSlice.reducer;
const Actions = logicSlice.actions;

export { Reducer, Actions };
